/**
 * TEXTOS DA CERES-PRP-011 (estilos, pacotes, prévia em PDF, destinatário) — português.
 *
 * Em módulo próprio, como os da UX-001 e da pré-venda; o tipo de `EN` obriga a
 * paridade.
 */

export const PRP_PT = {
  'gerar.oportunidadeSemTitulo': 'Oportunidade sem título',
  'gerar.estiloSelecionado': 'Estilo selecionado:',
  'gerar.estiloEscolhidoNaGaleria': 'estilo escolhido na galeria',
  'gerar.alterarEstilo': 'Alterar estilo',
  'gerar.passoEmpresa': 'Empresa',
  'gerar.empresaNome': 'Nome',
  'gerar.empresaRazao': 'Razão social',
  'gerar.empresaCnpj': 'CNPJ',
  'gerar.cnpjNaoCadastrado': 'Não cadastrado — não será inventado no documento',
  'gerar.empresaSegmento': 'Segmento',
  'gerar.empresaEndereco': 'Localização',
  'gerar.empresaSite': 'Site',
  'gerar.contatoDaOportunidade': 'na oportunidade',
  'gerar.cargoNaoInformado': 'Cargo não informado',
  'gerar.emailNaoInformado': 'E-mail não informado',
  'gerar.verGaleria': 'Ver a galeria de estilos',
  'gerar.modeloDaOrganizacao': 'Modelo da sua organização',
  'gerar.sugerido': 'sugerido',
  'gerar.pacote': 'Pacote de conteúdo',
  'gerar.pacoteDoModelo': 'A estrutura vem do próprio modelo da organização.',
  'proposta.pacote.PROJECT': 'Projeto',
  'proposta.pacote.SERVICE': 'Serviço',
  'proposta.pacote.OUTSOURCING': 'Outsourcing',
  'proposta.pacote.PRODUCT': 'Produto',
  'proposta.pacote.LICENSE': 'Licença',
  'proposta.pacote.TECHNICAL': 'Técnico',
  'proposta.pacoteAjuda.PROJECT': 'Escopo, entregáveis, metodologia, cronograma e equipe.',
  'proposta.pacoteAjuda.SERVICE':
    'Serviço contínuo: escopo, modelo de atendimento e responsabilidades.',
  'proposta.pacoteAjuda.OUTSOURCING': 'Alocação: cenário, equipe, responsabilidades e premissas.',
  'proposta.pacoteAjuda.PRODUCT': 'Produtos: solução, itens, investimento e condições.',
  'proposta.pacoteAjuda.LICENSE': 'Licenças: solução, itens, responsabilidades e exclusões.',
  'proposta.pacoteAjuda.TECHNICAL': 'Técnico: cenário, escopo, metodologia e premissas detalhadas.',
  'modelo.estiloMINIMAL': 'Minimalista',
  'modelo.estiloDescricaoMINIMAL': 'Monocromático, centrado e com o máximo de respiro.',
  'desconto.frase': 'Desconto de {percentual} sobre o valor de tabela',
  'pdf.pagina': 'página',
  'pdf.de': 'de',
  'pdf.carregando': 'Desenhando o documento…',
  'pdf.falhou': 'Não foi possível desenhar o documento. Abra o PDF ou tente de novo.',
  'editor.dadosDoDocumentoSalvos': 'Dados do documento atualizados.',
  'editor.estilo': 'Estilo',
  'editor.destinatario': 'Destinatário',
  'editor.validade': 'Validade da proposta',
  'editor.validadeAusente': 'Sem validade: informe antes de finalizar.',
  'editor.validaAte': 'Válida até',
  'editor.inferido': 'inferido',
  'editor.bibliotecaDeBlocos': 'Biblioteca de blocos',
  'editor.documentoAtualizando': 'Atualizando o documento…',
  'editor.documentoSincronizado': 'Mesmo arquivo do PDF final',
  'editor.fonte': 'Fonte',
  'editor.baixarPdf': 'Baixar PDF',
  'estadoDoBloco.DAS_FONTES': 'Preenchido pelas fontes',
  'hist.DADOS_DO_RASCUNHO_ALTERADOS': 'Destinatário ou validade alterados',
  'modelos.usarEstilo': 'Usar estilo',
  'modelos.capa': 'capa',
  'modelos.paginaInterna': 'página interna',
  'proposta.emPreparacao': 'em preparação',
  'propostas.novaProposta': 'Nova proposta',
  'propostas.acao.CONTINUAR': 'Continuar',
  'propostas.acao.REVISAR': 'Revisar',
  'propostas.acao.ACOMPANHAR': 'Acompanhar',
  'propostas.acao.ABRIR': 'Abrir',
  'propostas.acao.NOVA_VERSAO': 'Criar nova versão',
  'bloco.fonte.CRM': 'dados do CRM',
  'bloco.fonte.BRIEFING': 'briefing da oportunidade',
  'bloco.fonte.CATALOGO': 'Catálogo',
  'bloco.fonte.PLAYBOOK': 'Playbook',
  'bloco.fonte.INSTITUCIONAL': 'conteúdo institucional',
  'bloco.fonte.MODELO': 'texto padrão',
  'bloco.fonte.IA': 'sugestão da IA',
  'bloco.fonte.MANUAL': 'escrito por você',
  'bloco.fonte.SEM_FONTE': 'sem fonte',
  'bloco.confianca.ALTA': 'alta',
  'bloco.confianca.MEDIA': 'média',
  'bloco.confianca.INFERIDA': 'inferida — revise',
  'bloco.confianca.SEM_FONTE': 'sem fonte',
  'bloco.tipo.COVER': 'Capa',
  'bloco.tipo.COVER_LETTER': 'Carta de apresentação',
  'bloco.tipo.SUPPLIER': 'Sobre nossa empresa',
  'bloco.tipo.CUSTOMER': 'Sobre o cliente',
  'bloco.tipo.CURRENT_SCENARIO': 'Cenário atual',
  'bloco.tipo.CONTEXT': 'O que entendemos',
  'bloco.tipo.OBJECTIVES': 'Objetivos',
  'bloco.tipo.SOLUTION': 'Solução proposta',
  'bloco.tipo.ITEMS': 'Produtos e serviços',
  'bloco.tipo.SCOPE': 'Escopo',
  'bloco.tipo.DELIVERABLES': 'Entregáveis',
  'bloco.tipo.METHODOLOGY': 'Metodologia',
  'bloco.tipo.SCHEDULE': 'Cronograma',
  'bloco.tipo.TEAM': 'Equipe',
  'bloco.tipo.INVESTMENT': 'Investimento',
  'bloco.tipo.COMMERCIAL_TERMS': 'Condições comerciais',
  'bloco.tipo.ASSUMPTIONS': 'Premissas',
  'bloco.tipo.RESPONSIBILITIES': 'Responsabilidades',
  'bloco.tipo.EXCLUSIONS': 'Fora do escopo',
  'bloco.tipo.CASES': 'Casos e referências',
  'bloco.tipo.NEXT_STEPS': 'Próximos passos',
  'bloco.tipo.VALIDITY': 'Validade',
  'bloco.tipo.ACCEPTANCE': 'Aceite',
  'bloco.tipo.FREE_TEXT': 'Texto livre',
  'bloco.tipo.SIMPLE_TABLE': 'Tabela',
  'bloco.tipo.IMAGE': 'Imagem',
  'bloco.tipo.PAGE_BREAK': 'Quebra de página',
  'modelo.layoutBLOCO_SUPERIOR': 'Bloco de cor no topo',
  'modelos.secaoEstilos': 'Estilos visuais',
  'modelos.secaoDaOrganizacao': 'Modelos da sua organização',
};
